/*
 * Celvoir productpagina (opbouw naar voorbeeld laurentmonaco.fr), 2026-10-21.
 * - Vaste balk onderin (mobiel/tablet): variant kiezen + toevoegen, zichtbaar zolang
 *   de gewone "Ajouter au panier"-knop niet in beeld is.
 * - Titel van de gerelateerde producten: "Complétez votre tenue".
 */
(function () {
  'use strict';

  if (window.__celvoirPdp) return;
  window.__celvoirPdp = true;

  var bar = document.querySelector('[data-cv-sticky]');
  var section = bar && bar.closest('[data-section-type="product"], .shopify-section');
  if (!section) section = document.querySelector('.shopify-section[id*="__main"]');
  if (!section) return;

  function mainButton() {
    return section.querySelector('.product__block--buttons button[name="add"], .product__block--buttons [data-add-to-cart]');
  }

  function mainVariantId() {
    var input = section.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? String(input.value) : '';
  }

  /* ---------- Vaste balk ---------- */
  if (bar) {
    document.body.appendChild(bar);
    var select = bar.querySelector('[data-cv-sticky-select]');
    var addButton = bar.querySelector('[data-cv-sticky-add]');
    var label = { add: 'Ajouter au panier', soldOut: 'Épuisé' };

    var syncFromMain = function () {
      var id = mainVariantId();
      if (select && id && select.value !== id && select.querySelector('option[value="' + id + '"]')) {
        select.value = id;
      }
      var main = mainButton();
      if (main && addButton) {
        var disabled = !!main.disabled;
        addButton.disabled = disabled;
        addButton.textContent = disabled ? label.soldOut : label.add;
      }
    };

    if (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var values = [];
        try { values = JSON.parse(option.getAttribute('data-options') || '[]'); } catch (e) {}
        values.forEach(function (value, index) {
          var wrap = section.querySelector('[data-option-position="' + (index + 1) + '"]');
          if (!wrap) return;
          var inputs = wrap.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value === value) {
              if (!inputs[i].checked) {
                /* Zonder klik/focus, zodat de pagina niet naar de opties springt */
                inputs[i].checked = true;
                inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
              }
              break;
            }
          }
        });
        setTimeout(syncFromMain, 250);
      });
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        var main = mainButton();
        if (main && !main.disabled) main.click();
      });
    }

    section.addEventListener('change', function () { setTimeout(syncFromMain, 150); });

    var mq = window.matchMedia('(max-width: 989px)');
    var mainInView = false;
    var update = function () {
      var show = mq.matches && !mainInView;
      bar.hidden = !show;
      document.documentElement.classList.toggle('cv-sticky-on', show);
    };

    var main = mainButton();
    if (main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mainInView = entries[entries.length - 1].isIntersecting;
        update();
      }).observe(main);
    }
    if (mq.addEventListener) mq.addEventListener('change', update);
    else if (mq.addListener) mq.addListener(update);

    syncFromMain();
    update();
  }

  /* ---------- "Complétez votre tenue" ---------- */
  document.querySelectorAll('.shopify-section[id*="__related"]').forEach(function (related) {
    var walker = document.createTreeWalker(related, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (/produits associ[ée]s/i.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/produits associ[ée]s/i, 'Complétez votre tenue');
    }
  });
})();
